import React from 'react';
import { useGeneral } from '../../../contexts';
import styles from './ComingSoon.module.css';

interface ComingSoonProps {
  titleKey?: string;
  descriptionKey?: string;
  defaultTitle?: string;
  defaultDescription?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({
  titleKey = 'organizerPanel.comingSoon',
  descriptionKey = 'organizerPanel.comingSoonDescription',
  defaultTitle = 'Yakında Gelecek',
  defaultDescription = 'Bu özellik yakında eklenecektir.'
}) => {
  const { language } = useGeneral();
  const { getTranslation } = language;

  return (
    <div className={styles.comingSoonPage}>
      <div className={styles.comingSoonBox}>
        <h2 className={styles.comingSoonTitle}>
          {getTranslation(titleKey) || defaultTitle}
        </h2>
        <p className={styles.comingSoonText}>
          {getTranslation(descriptionKey) || defaultDescription}
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
